<div *ngIf="service"
     [ngClass]="{'selected': isSelected}"
     class="tr layout-column md-no-proxy fade-element-in-only full-width"
     (click)="onToggle($event)">

  <div class="flex layout-row">
    <!--Checkbox / Toggle Button-->
    <div class="layout-column layout-align-start-start small margin-left-5">
      <app-bringoz-checkbox [isChecked]="isSelected"
                            (clickEvent)="onToggle($event)"></app-bringoz-checkbox>
    </div>

    <!--Main Info-->
    <div class="layout-column flex margin-right-10 margin-left-10 gap-2">

      <!--Icons / Account / ID-->
      <div class="layout-row layout-align-start-center text-ellipsis gap-10">
        <app-bringoz-status-tag [status]="service.status"
                                [isSmall]="true">

        </app-bringoz-status-tag>

        <app-service-info-button [service]="service">

        </app-service-info-button>

        <app-service-packed-indication *ngIf="!!service.packageList"
                                       [packageList]="service.packageList"
                                       [packedDate]="service.packedDate"
                                       [isPacked]="service.autoGeneratedPacked"
                                       [packingInfo]="service.packingInfo"
                                       [serviceType]="service.serviceType">

        </app-service-packed-indication>

        <app-entity-relations-indicator *ngIf="!!service.taskList.length" [service]="service"></app-entity-relations-indicator>

        <bringoz-icon *ngIf="service.routeId"
                      iconName="route"
                      fill="#484848"
                      [ngbTooltip]="service.routeId"
                      openDelay="300">
        </bringoz-icon>

        <app-service-agent-comment-indication [service]="service"></app-service-agent-comment-indication>

        <span class="flex"></span>

        <app-shipper-account-link [account]="service.account" [user]="service.user"></app-shipper-account-link>
      </div>

      <!--Service Type And Link / Driver-->
      <div class="layout-row layout-align-start-center text-ellipsis">
        <app-service-link [id]="service.id"
                          [serviceType]="service.serviceType"
                          [externalId]="service.externalId"></app-service-link>

        <app-service-type-indication [serviceType]="service.serviceType"
                                     class="br-caption-2 margin-left-10"></app-service-type-indication>

        <span *ngIf="service.displayId" class="margin-left-10 md-tiny">| {{service.displayId}}</span>

        <span class="flex"></span>

        <div class="layout-row">
          <bringoz-icon *ngIf="service.agent?.agentType === 'Driver'" iconName="agent"></bringoz-icon>
          <bringoz-icon *ngIf="service.agent?.agentType === 'ServiceAgent'" [iconName]="'contact-circle'" [fill]="'#7e7e7e'"></bringoz-icon>

          <app-agent-itinerary-link [linkToAgentView]="true"
                                    [agent]="service.agent"
                                    [isShowCopyButton]="true">
          </app-agent-itinerary-link>
        </div>

      </div>

      <!--Contact-->
      <div class="layout-row layout-align-start-center text-ellipsis" *ngIf="service.taskList[0].taskSpec.contact.name">
        <bringoz-icon class="margin-right-5" [iconName]="'contact-circle'" [fill]="'#7e7e7e'"></bringoz-icon>

        <span bringoz-ppi
              *ngFor="let task of service.taskList; let last = last"
              class="md-tiny text-ellipsis text">
          {{task.taskSpec.contact.name}} {{!last ? ' | ' : ''}}
        </span>
      </div>

      <div *ngFor="let task of service.taskList" class="layout-row layout-align-start-center">
        <app-task-purpose [purpose]="task.taskSpec.purpose"
                          [firstLetterOnly]="true"
                          class="margin-right-10"></app-task-purpose>

        <!--Location-->
        <div class="flex layout-row text-ellipsis align-items-center">
          <span class="text">{{task.taskSpec.address | bringozAddress}}</span>
          <app-address-quality [address]="task.taskSpec.address"></app-address-quality>
        </div>

        <!--ETA-->
        <div class="flex-none layout-row">\
          <bringoz-icon icon-name="clock" fill="#7e7e7e"></bringoz-icon>
          <app-task-eta class="br-caption-2" [task]="task"></app-task-eta>
        </div>
      </div>

      <!--Time Window-->
      <div class="layout-row layout-align-start-center">
        <bringoz-icon [iconName]="'time-window-outline'" [fill]="'#7e7e7e'"></bringoz-icon>
        <span class="text margin-left-5">{{service | timeWindow}}</span>
      </div>

    </div>
  </div>
</div>

